import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import ScanInput from '../../components/Inputs/ScanInput/ScanInput'
import ItemSelectableSimple from '../../components/ItemSelectable/ItemSelectableSimple'
import manualAccessLogo from '.././../assets/manual-access-img.svg'
import { t } from 'i18next'
import { getTenantInfoByKey } from '../../helpers/helpers'
import AccessContext from '../../context/AccessContext/AccessContext'
import AccessVehiclesContext from '../../context/AccessVehiclesContext/AccessVehiclesContext'
const QRScanAccess = () => {
  const navigate = useNavigate();

  const { clean, setVisit } = useContext(AccessContext);
  const { cleanAccessVehiclesState } = useContext(AccessVehiclesContext);

  const handleCheckAccess = (scanResponse) => {
    clean();
    cleanAccessVehiclesState()
    if (getTenantInfoByKey('qr_employee_type') === 'ar-DNI') {
      setVisit({
        document: scanResponse.documentNumber,
        full_name: `${scanResponse.name} ${scanResponse.lastName}`,
        reason: '',
      })
      navigate(`/createAccess/${scanResponse.documentNumber}`)
    } else {
      navigate(`/createAccess/${scanResponse}`)
    }
  }

  return (
    <div className='h-100' style={{ background: 'var(--gray-50)' }}>
      <div className="d-flex flex-column justify-content-between h-100">
        <div className='ps-4 pe-4'>
          <h5 className='gray-950-color text-center mb-5 mt-2' style={{ fontSize: '18px' }}>
            {t('SCAN_OR_CODE_DNI')}
          </h5>
          <ScanInput onScannResult={handleCheckAccess} />
        </div>
        <div
          className='ps-3 pe-3 pt-3 pb-3'
          style={{ background: 'var(--gray-200)', borderRadius: '20px 20px 0 0' }}
        >
          <ItemSelectableSimple onClick={() => navigate('/manualAccess')}>
            <div className='d-flex align-items-center gap-2'>
              <img src={manualAccessLogo} alt="" />
              <div>
                <h5 className='m-0'>{t('MANUAL_ENTRY')}</h5>
                <span className='subtitle'>{t('WRITE_ID')}</span>
              </div>
            </div>
          </ItemSelectableSimple>
        </div>
      </div>
    </div>
  )
}

export default QRScanAccess